import { useTranslation } from "react-i18next";
import {
  Badge,
  Card,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import React from "react";
import { PlanDto } from "../../../interfaces/plan/plan.dto";

type TProps = PlanDto & {
  onEdit?: () => void;
  onDelete?: () => void;
  onToggleState?: () => void;
};
export const Plan: React.FC<TProps> = ({
  isActive,
  name,
  price,
  grade,
  sequenceNumber,
  isWebPaymentProcess,
  isWebListing,
  isTopSelling,
  onEdit,
  onDelete,
  onToggleState,
}) => {
  //#region hooks
  const { t, i18n } = useTranslation();
  //#endregion

  return (
    <React.Fragment>
      <Card className="card-body">
        <UncontrolledDropdown direction="end" className="text-end">
          <DropdownToggle tag="a" id="dropdownMenuLink2" role="button">
            <i className="ri-more-fill fs-17"></i>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              style={{
                alignSelf: "flex-start",
                display: "flex",
              }}
              className="dropdown-item edit-list"
              onClick={onEdit}
            >
              <i className="ri-pencil-line me-2 align-bottom text-muted"></i>
              {t("edit")}
            </DropdownItem>
            <DropdownItem
              style={{
                alignSelf: "flex-start",
                display: "flex",
              }}
              className="dropdown-item edit-list"
              onClick={onToggleState}
            >
              <i
                className={`${
                  isActive
                    ? "ri-forbid-line"
                    : "ri-checkbox-circle-line text-danger"
                }  me-2 align-bottom text-muted`}
              ></i>
              {isActive ? t("inactivate") : t("activate")}
            </DropdownItem>
            <DropdownItem
              style={{
                alignSelf: "flex-start",
                display: "flex",
              }}
              className="dropdown-item remove-list"
              onClick={onDelete}
            >
              <i className="ri-delete-bin-5-line me-2 align-bottom text-muted"></i>
              {t("delete")}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        <div className="d-flex mb-4 align-items-center text-center">
          <div className="flex-grow-1">
            <h4 className="card-title mb-1">
              {i18n.language === "ar" ? name.ar : name.en}
            </h4>
            <h5 className="card-title mt-2 mb-1">
              {t("price")}: {price}
            </h5>
            <h6 className="card-title mt-2 mb-1 text-muted">
              {i18n.language === "ar" ? grade?.name?.ar : grade?.name?.en}
            </h6>
            <h6 className="card-title fs-14 mt-2 mb-1 text-muted">
              {t("webPaymentProcess")}{" "}
              <span
                className={
                  isWebPaymentProcess === true
                    ? "text-primary"
                    : "text-secondary"
                }
              >
                {isWebPaymentProcess === true
                  ? `[${t("yes")}]`
                  : `[${t("no")}]`}
              </span>
            </h6>
            <h6 className="card-title fs-14 mt-2 mb-1 text-muted">
              {t("listOnWebHomePage")}{" "}
              <span
                className={
                  isWebListing === true ? "text-primary" : "text-secondary"
                }
              >
                {isWebListing === true ? `[${t("yes")}]` : `[${t("no")}]`}
              </span>
            </h6>
            <h6 className="card-title fs-14 mt-2 mb-1 text-muted">
              {t("topSelling")}{" "}
              <span
                className={
                  isTopSelling === true ? "text-primary" : "text-secondary"
                }
              >
                {isTopSelling === true ? `[${t("yes")}]` : `[${t("no")}]`}
              </span>
            </h6>
          </div>
        </div>

        <h6 className="mb-3 d-flex justify-content-center">
          <Badge color={`${isActive ? "primary" : "danger"}`}>
            {isActive ? t("active") : t("inActive")}
          </Badge>
          &nbsp;
          <Badge color={`${"secondary"}`}>{sequenceNumber}</Badge>
        </h6>
      </Card>
    </React.Fragment>
  );
};
